import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import moment from "moment";
import DataTable from "react-data-table-component";
import { makeStyles } from "@mui/styles";
import LinearProgress from "@mui/material/LinearProgress";
import Tooltip from "@mui/material/Tooltip";
import VisibilityIcon from "@mui/icons-material/Visibility";
import EditIcon from "@mui/icons-material/Edit";
import styles from "assets/jss/material-dashboard-pro-react/views/extendedTablesStyle.js";
import useEquipmentsTable from "./useEquipmentsTable.js";
import Button from "components/CustomButtons/Button.js";
import styled from "styled-components";
import AdvancedSearchContext from "context/AdvancedSearchContext";
import UserService from "services/UserService";
import { getSchedules, getGEBScripts } from "services/ConfigServices";
import { equipmenttext, pointtext } from "variables/MBM/equipments";
import { definitionData, fieldprotocoleData, eosprotocoleData, stateData } from "variables/MBM/lists/equipments";
import { dico } from "variables/lists/dico";
import Dialog from "@mui/material/Dialog";
import { withStyles } from "@mui/styles";
import MuiDialogContent from "@mui/material/DialogContent";
import MuiDialogActions from "@mui/material/DialogActions";
import CustomDialogTitle from "components/Dialog/CustomDialogTitle.js";
import { Pilotage, Override, Data as DataIcon } from "components/CustomIcon/CustomIcon";
import { hardwareData } from "variables/MBM/lists/equipments";

const GroupCell = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
`;

const Container = styled.div`
  border: solid;
  border-width: 1px;
  border-color: #EEEEEE;
  background-color: white;
  margin-top: -0.5px;
  padding-top: 5px;
  overflow-x: auto;
  width: 100%;
`;

const ExpandableContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0.5rem 4rem 2rem;
`;
const ExpandableElement = styled.div`
  display: flex;
  flex-direction: row;
  margin-left: ${(props) => props.marginleft};
`;

const ElementTitle = styled.div`
  font-weight: 600;
  font-size: 12px;
  font-family: "Source Sans Pro",sans-serif;
`;

const ElementData = styled.div`
  margin-left: 4px;
  font-weight: 400;
  font-size: 12px;
  font-family: "Source Sans Pro",sans-serif;
`;

const NoData = styled.p`
  font-size: 14px;
  font-weight: 600;
  margin-top: 20px;
  opacity: 1;
`;

const useStyles2 = makeStyles((theme) => ({
  "@keyframes flicker": {
    from: {
      opacity: 1
    },
    to: {
      opacity: 0.7
    }
  },
  flicker: {
    animationName: "$flicker",
    animationDuration: "1000ms",
    animationIterationCount: "infinite",
    animationDirection: "alternate",
    animationTimingFunction: "ease-in-out"
  },
  withAnimation: ({ disabled }) => ({
    animationPlayState: disabled ? "paused" : "running"
  })
}));

const DialogContent = withStyles((theme) => ({
  root: {
    padding: '16px',
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: '8px',
  },
}))(MuiDialogActions);

const useStyles = makeStyles(styles);

const RTEquipments = (props) => {
  const currentusertype = localStorage.getItem('userType');
  const permis = JSON.parse(localStorage.getItem("permission")) || [];
  const mbm_geb_control_schedules = permis.includes("mbm_geb_control_schedules");
  const mbm_geb_control_admin_override = permis.includes("mbm_geb_control_admin_override");
  const appContext = useContext(AdvancedSearchContext);
  const { groupInfoListById } = appContext;
  const { wpgroup, workspace } = props;
  const { gridState, refetch, setEquipmentsData,  equipmentsdata, setButtonDisabled } = useEquipmentsTable(wpgroup, workspace);
  const [tosave, setTosave] = useState(false);

  const classes = useStyles();
  const classes2 = useStyles2();



  const equipmentscolumns = [
    {
      name: equipmenttext.name,
      selector: (row) => row.name,
      sortable: true,
      maxWidth: "12rem",
      cell: (row) => row.name,
    },
    {
      name: equipmenttext.definition,
      selector: (row) => row.definition,
      sortable: true,
      maxWidth: "12rem",
      cell: (row) => definitionData.find((x) => x.id == row.definition)?.name || ""
    },
    {
      name: equipmenttext.hardware,
      selector: (row) => row.otherproperties?.hardware ? hardwareData.find((a) => a.id == row.otherproperties.hardware)?.name || equipmenttext.undefinedhardware : equipmenttext.undefinedhardware,
      sortable: true,
      maxWidth: "10rem",
      cell: (row) => row.otherproperties?.hardware ? hardwareData.find((a) => a.id == row.otherproperties.hardware)?.name || equipmenttext.undefinedhardware : equipmenttext.undefinedhardware
    },
    {
      name: equipmenttext.fieldprotocol,
      selector: (row) => row.connectionproperties?.fieldProtocol,
      sortable: true,
      maxWidth: "12rem",
      cell: (row) => fieldprotocoleData.find((x) => x.id == row.connectionproperties?.fieldProtocol)?.name || ""
    },
    {
      name: equipmenttext.eosprotocol,
      selector: (row) => row.connectionproperties?.eosprotocol,
      sortable: true,
      maxWidth: "12rem",
      cell: (row) => eosprotocoleData.find((x) => x.id == row.connectionproperties?.eosprotocol)?.name || ""
    },
    {
      name: equipmenttext.group,
      selector: (row) => row.groupid,
      sortable: true,
      maxWidth: "10rem",
      cell: (row) => groupInfoListById["" + row.groupid] || ""
    },
    {
      name: equipmenttext.lastconnection,
      selector: (row) => row.lastconnection && moment(row.lastconnection).isValid() ? row.lastconnection : 0,
      sortable: true,
      maxWidth: "12rem",
      cell: (row) =>
        row.lastconnection && moment(row.lastconnection).isValid()
          ? moment(row.lastconnection).format("DD/MM/YYYY HH:mm")
          : "",
    },
    {
      name: equipmenttext.included,
      selector: (row) => row.otherproperties?.workspaces?.find((w) => w.id === workspace.id) ? equipmenttext.yes : equipmenttext.no,
      sortable: true,
      maxWidth: "10rem",
      cell: (row) => row.otherproperties?.workspaces?.find((w) => w.id === workspace.id) ? equipmenttext.yes : equipmenttext.no,
    },
  ];

  const conditionalRowStyles = [
    {
      when: row => row.otherproperties?.workspaces?.find((w) => w.id === workspace.id),
      style: {
        backgroundColor: '#6B3CC8',
        color: 'white',
      },
    },
  ];

  const handleOnRowClicked = (row) => {
    if(row.otherproperties?.workspaces?.find((w) => w.id === workspace.id))
    {
      row.otherproperties.workspaces = row.otherproperties.workspaces.filter((w) => w.id !== workspace.id);
    }
    else
    {
      if(!row.otherproperties)
        row.otherproperties = {};
      if(!row.otherproperties.workspaces)
        row.otherproperties.workspaces = [];
      row.otherproperties.workspaces.push({id:workspace.id});
    }
    setEquipmentsData({...equipmentsdata});
    setButtonDisabled(false);
  }

  return (
    <>
      <DataTable
        paginationRowsPerPageOptions={[10, 20, 30, 50, 100]}
        title={equipmenttext.includedequipments}
        noDataComponent={<NoData>Aucun équipement à afficher</NoData>}
        noHeader={true}
        columns={equipmentscolumns}
        pointerOnHover={true}
        manual={true}
        onRowClicked={handleOnRowClicked}
        conditionalRowStyles={conditionalRowStyles}
        persistTableHead
        pagination
        subHeader
        progressPending={gridState.loading}
        progressComponent={<LinearProgress />}
        paginationComponentOptions={{
          noRowsPerPage: false,
          rowsPerPageText: "Lignes par page",
          rangeSeparatorText: "sur",
          selectAllRowsItem: false,
          selectAllRowsItemText: "Selectionner toutes les lignes",
        }}
        {...gridState}
      />
    </>
  );
};

export default RTEquipments;
